<template>
	<component
		:is="tag"
		:class="[
			settings.sizes[size],
			settings.variants[variant],
			settings.colors[color],
			truncate ? 'truncate w-full' : null,
		]"
	>
		<slot />
	</component>
</template>

<script setup>
import {defineSettings} from '../composables/component';

const settings = defineSettings('NkMeta');

defineProps({
	tag: {
		type: String,
		default: 'span',
		required: false,
	},
	size: {
		type: String,
		default: 'sm',
		required: false,
	},
	variant: {
		type: String,
		default: 'default',
		required: false,
	},
	color: {
		type: String,
		default: 'type-light',
		required: false,
	},
	truncate: {
		type: Boolean,
		default: false,
		required: false,
	},
});
</script>
